import { FC } from "react";
import { IconPropsType } from ".";

export const TurnDown: FC<IconPropsType> = (props) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 1H9.66667C7.88889 1 4.33333 2.09714 4.33333 6.48571C4.33333 10.8743 4.33333 12.4286 4.33333 12.6571M1 9.57143L4.33333 13L7.66667 9.57143"
        stroke={props.color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
